import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import { LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components'
import VChart from 'vue-echarts'
import { getCSSVar, getLocaleString, isVisible, scrollStop } from '@/shared/helpers'
import { onMounted, onUnmounted, PropType, Ref, ref, watch } from 'vue'
import { EChartsOption } from 'echarts'

interface Product {
	name: string,
	color: string,
	percent: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartPie',
  props: {
	products: {
		type: Array as PropType<Product[]>,
		default() {
			return [
				{
					name: 'Пиво',
					color: getCSSVar('warning-color'),
					percent: 56.1
				},
				{
					name: 'Пуарэ',
					color: getCSSVar('primary-color'),
					percent: 13.6
				},
				{
					name: 'Медовуха',
					color: getCSSVar('success-color'),
					percent: 16.2
				},
				{
					name: 'Пунш',
					color: getCSSVar('spirt-color'),
					percent: 12.2
				},
				{
					name: 'Прочее',
					color: getCSSVar('secondary-text-color'),
					percent: 25.6
				}
			]
		}
	},
	instantInit: {
		type: Boolean,
		default() {
			return false
		}
	},
	selected: String,
	range: {
		type: String,
		default: () => ''
	},
	action3nd: {
		type: String,
		default: () => ''
	}
},
  emits: [
	'mousein',
	'mouseout'
],
  setup(__props, { emit: emits }) {

const props = __props;

use([
	CanvasRenderer,
	PieChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent
])





const chartWrapper = ref(null)

const chart = ref(null)

const option: Ref<EChartsOption> = ref(null)

watch(() => props.selected, (newValue, oldValue) => {
	if (newValue) {
		chart.value.dispatchAction({
			type: 'highlight',
			name: newValue
		})

		chart.value.dispatchAction({
			type: 'downplay',
			name: oldValue
		})
	} else {
		chart.value.dispatchAction({
			type: 'downplay',
			name: oldValue
		})
	}
})

const chartInit = () => {
	if (props.instantInit || (isVisible(chartWrapper.value) && !option.value)) {
		// noinspection TypeScriptValidateTypes
		option.value = {
			tooltip: {
				trigger: 'item',
				renderMode: 'html',
				formatter(params) {
					return `
            <div class="report-tooltip">
              <div class="report-tooltip__title">${params.name}: </div>
              <span class="report-tooltip__text">
								${getLocaleString(params.value)}
							</span>
              тыс. декалитров (дал) <br/>
              <span class="report-tooltip__text">
								${params.data.percent}%
							</span> в общем объеме ${props.action3nd}
              <div>${props.range.toString().toLowerCase()}</div>
            </div>
          `
				}
			},
			legend: {
				show: false
			},
			series: [
				{
					name: 'Структура производимой продукции',
					type: 'pie',
					radius: ['30%', '90%'],
					center: ['50%', '50%'],
					roseType: 'area',
					avoidLabelOverlap: false,
					label: {
						show: false
					},
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					},
					data: props.products.map(item => {
						return {
							value: item.value,
							name: item.name,
							percent: item.percent,
							itemStyle: {
								color: item.color,
								borderWidth: item.percent < 5 ? 3 : 0,
								borderColor: item.color,
								borderJoin: 'miter',
								borderMiterLimit: 10
							}
						}
					})
				}
			]
		}

		chart.value.chart.on('mouseover', (e) => {
			emits('mousein', e)
		})

		chart.value.chart.on('mouseout', (e) => {
			emits('mouseout', e)
		})
	}
}

onMounted(() => {
	scrollStop(chartInit)

	chartInit()
})

onUnmounted(() => {
	chart.value?.clear()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "chartWrapper",
    ref: chartWrapper,
    class: "chart-wrapper"
  }, [
    _createVNode(_unref(VChart), {
      ref_key: "chart",
      ref: chart,
      class: "chart",
      option: option.value
    }, null, 8, ["option"])
  ], 512))
}
}

})